/**
 * Renders reasoning text within the thinking section.
 * Muted styling to visually distinguish from the final response.
 * Receives props from ChainOfThoughtPrimitive.Parts (ReasoningMessagePartProps).
 */
export function InlineReasoning(props: { text: string; [key: string]: unknown }) {
  if (!props.text) return null;
  return (
    <div className="text-sm text-muted-foreground">{props.text.trim()}</div>
  );
}
